<template>
    <div class="world-wrap">
        <a-row style="height: 100%">
            <a-col :span="18" style="height: 100%">
                <div id="worldMap"></div>
            </a-col>
            <a-col :span="6">
                <div class="dataBox">
                    <div v-for="item in data" class="itembox">
                        <div class="percent">{{(item.value / allCount * 100).toFixed(1)}}%</div>
                        <div class="name">{{item.name}}</div>
                    </div>
                </div>
            </a-col>
        </a-row>
    </div>
</template>

<script>
  import { worldData } from '../world'

  export default {
    name: 'worldMap',
    props: {
      data: Array
    },
    computed: {
      allCount() {
        let data = 0
        this.data.forEach(item => {
          data += item.value
        })
        return data
      }
    },
    data() {
      return {
        worldMap: null
      }
    },
    watch: {
      data() {
        this.$nextTick(() => {
          this.initWordMap()
        })
      }
    },
    methods: {
      initWordMap() {
        this.worldMap = this.$echarts.init(document.getElementById('worldMap'))
        let option = {
          grid: {
            width: '100%',
            height: '100%',
            left: '0%',
            right: '0%',
            bottom: '0%',
            containLabel: true
          },
          series: [
            {
              type: 'map', // 类型
              mapType: 'world', // 地图类型
              roam: false, // 是否支持缩放和拖动
              zoom: 1.2,
              // 地图区域的多边形 图形样式
              itemStyle: {
                areaColor: '#ddd', // 地图区域的颜色 如果设置了visualMap，areaColor属性将不起作用
                borderWidth: 1, // 描边线宽 为 0 时无描边
                borderColor: '#fff' // 图形的描边颜色 支持的颜色格式同 color，不支持回调函数
              },
              // 高亮状态下的多边形和标签样式
              emphasis: {
                label: {
                  show: true, // 是否显示标签
                  color: '#333' // 文字的颜色 如果设置为 'auto'，则为视觉映射得到的颜色，如系列色
                },
                itemStyle: {
                  areaColor: 'rgb(137,151,255)' // 地图区域的颜色
                }
              },
              nameMap: worldData.nameMap,
              data: this.data.map(item => {
                return { ...item, selected: true }
              }),
              label: {
                normal: {
                  formatter: function(params) { //标签内容
                    if (params.value) {
                      return params.name + params.value
                    } else {
                      return
                    }
                  },
                  lineHeight: 20,
                  backgroundColor: 'rgba(255,255,255,.9)',
                  borderColor: '#80cffd',
                  borderWidth: '1',
                  padding: [5, 15],
                  color: '#000000',
                  fontSize: 14
                }
              }
            }
          ]
        }
        this.worldMap.setOption(option)
      }
    }
  }
</script>

<style scoped lang="less">
    .world-wrap {
        width: 100%;
        height: 300px;
        background: #fff;

        #worldMap {
            height: 100%;
            width: 100%;
        }

        .dataBox {
            display: flex;
            flex-wrap: wrap;
            padding-top: 15px;
            box-sizing: border-box;

            .itembox {
                width: 50%;
                text-align: left;
                margin-bottom: 20px;
            }

            .percent {
                font-size: 34px;
                font-weight: 500;
                color: #3C93FF;
            }

            .name {
                font-size: 14px;
                font-weight: 500;
                color: #333333;
            }
        }
    }
</style>
